import { Calendar } from 'lucide-react';

const Header = () => {
  return (
    <div className="shrink-0 bg-white z-10">
      <div className="p-6 border-b border-slate-100">
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50 text-blue-600 shrink-0">
            <Calendar className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-sm font-bold text-secondary-900 leading-tight flex items-center gap-2">
              Scheduling Management
            </h2>
            <p className="text-[10px] text-secondary-500 mt-0.5 leading-normal">
              Review patient scheduling preferences and manage appointment booking
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
